import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-796b58a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { computed, watch, ref, onMounted, nextTick } from 'vue';
import gsap from 'gsap'
import { useGameState, useAppState } from '@/services/composition';
import { STAND_HEIGHT } from '@/webgl/activities/desktop/controllers/CameraController'
import frames from '@/utils/FrameToTime'
import Viewport from '@/store/modules/Viewport';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const { send } = useAppState()

const position = computed(() => {
  return state.value.context.isCrouched ? 'player-crouch' : 'player-stand'
})

const isTutoCrouch = computed(()=> {
  return state.value.matches('tuto.xr.crouch')
})

const inFog = computed(() => {
  const fogHeight = state.value.context.fogPreset.ceilingHeight
  if (!state.value.context.fogPreset.ceilingHeight) return

  return (fogHeight < STAND_HEIGHT && state.value.matches('game.corridor')) && !state.value.context.isCrouched
})

const onClick = () => {
  if(Viewport.isDesktop) {
    return
  }

  send({ type: 'GAME_CROUCH_PLAYER', payload: !state.value.context.isCrouched })
}

const background = ref(null)
const warnTL = ref<gsap.core.Timeline>(null)
const createWarnTL = () => {
  const $ = gsap.utils.selector(background.value)
    warnTL.value?.kill()
    const tl = gsap.timeline(
      {
        repeat: -1
      }
    )
    tl.fromTo(
      $('.circle'),
      {
        scale: 1,
        opacity: 1
      },
      {
        scale: 96 / 40,
        opacity: 0,
        duration: frames(60),
        stagger: frames(5),
        ease: 'quint.inOut'
      }
    )

    warnTL.value = tl
}

watch(inFog, (shouldCrouch) => {
  if (shouldCrouch) {
    createWarnTL()
  } else {
    warnTL.value?.pause(0)
  }
})

onMounted(async () => {
  await nextTick()
  if (isTutoCrouch.value && !state.value.context.isCrouched) {
    createWarnTL()
  } else {
    warnTL.value?.pause(0)
  }
})

watch(isTutoCrouch, (isTutoCrouch) => {
  if (!isTutoCrouch) {
    warnTL.value?.pause(0)
  }
  if (!state.value.context.isCrouched) {
    createWarnTL()
  } else {
    warnTL.value?.pause(0)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["player-stand-status", [ { 'tuto': _unref(state).matches('tuto.xr.crouch') } ]]),
        onClick: onClick
      }, [
        _createElementVNode("div", {
          ref_key: "background",
          ref: background,
          class: "background"
        }, _hoisted_3, 512),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              class: "icon",
              key: _unref(position)
            }, [
              _createVNode(_component_ui_icon, { name: _unref(position) }, null, 8, ["name"])
            ]))
          ]),
          _: 1
        })
      ], 2)
    ]),
    _: 1
  }))
}
}

})